import React from 'react';
import styled from 'styled-components';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import TrueImpactSimpleModal from 'shared/design-system/components/TrueImpactSimpleModal';
import TrueImpactAlertIcon from 'shared/design-system/components/TrueImpactAlertIcon';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const PROGRAM_DONOR_NAME_MESSAGE =
  'A donor name has been detected in your program name. Please remove all references to individual donor names unless the donor has formal naming rights to the program. If you need to retain the donor name, your report will default to private and will not be available to share in the Impact Reporting Network.';

interface ProgramDonorNameModalProps {
  open: boolean;
  onKeepName: () => unknown;
  onCorrectName: () => unknown;
}

const StyledDiv = styled.div`
  padding: ${SPACERS.large} ${SPACERS.medium} ${SPACERS.medium};
  .icon-row {
    display: flex;
    justify-content: center;
    margin-bottom: ${SPACERS.medium};
  }
  .message {
    margin: 0;
    line-height: 1.7;
  }
`;

const ProgramDonorNameModal: React.FC<ProgramDonorNameModalProps> = ({
  open,
  onKeepName,
  onCorrectName,
}) => (
  <TrueImpactSimpleModal
    open={open}
    onClose={onCorrectName}
    contentStyle={{ maxWidth: 480, borderRadius: 4, overflow: 'hidden' }}
    next={{ text: 'Keep name and set private', onClick: onKeepName }}
    previous={{ text: 'Correct the name', onClick: onCorrectName }}
  >
    <StyledDiv>
      <div className="icon-row">
        <TrueImpactAlertIcon
          icon={faTriangleExclamation}
          color="warningDark"
          shadowOpacity={0.15}
        />
      </div>
      <p className="message">{PROGRAM_DONOR_NAME_MESSAGE}</p>
    </StyledDiv>
  </TrueImpactSimpleModal>
);

export default ProgramDonorNameModal;
